import React, { useEffect, useState } from "react";
import CheckTable from "views/admin/tables/components/CheckTable";
import ColumnsTable from "views/admin/tables/components/ColumnsTable";
import { useDisclosure } from "@chakra-ui/hooks";
import AddRestaurant from "./AddRestaurant";
import AdminDataService from "../../services/admin.service";
import { toast } from "react-toastify";
import { FaRegTrashAlt } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import EditRestaurant from "./EditRestaurant";

const RestaurantLists = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [allData, setAllData] = useState([]);
  const [isEdit, setIsEdit ] = useState(false);
  const [currData, setCurrData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  useEffect(() => {
    getRestauRants();
  }, []);

  const handleEdit = async (data) => {
    setIsEdit(true);
  }

  const getRestauRants = async () => {
    try {
      setIsLoading(true); // Set loading to true while fetching data
      const res = await AdminDataService.getAllRestaurant();
      if (res.data && res.data.status === "200") {
        setAllData(res.data.data);
      } else {
        toast.error("Something went wrong! Please try again later.");
      }
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setIsLoading(false); // Set loading to false after data retrieval
    }
  };

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure you want to delete this restaurant?");
      if (confirmDelete) {
        let options = {
          id: id,
        };
        const res = await AdminDataService.deleteRestaurant(options);
        if (res.data && res.data.status === "200") {
          getRestauRants();
          toast.success("Restaurant deleted successfully!");
        } else {
          toast.error("Failed to delete restaurant. Please try again later.");
        }
      }
    } catch (err) {
      toast.error("Failed to delete restaurant. Please try again later.");
    }
  };

  const columns = [
    {
      Header: "NAME",
      accessor: "restaurant_name",
    },
    {
      Header: "OWNER",
      accessor: "owner",
    },
    {
      Header: "PRODUCT",
      accessor: "drinks",
    },
    {
      Header: "TOTAL VOTES",
      accessor: "votes",
    },
    {
      Header: "POSITION",
      accessor: "position",
    },
    {
      Header: "ACTION",
    },
  ];

  return (
    <div className="mt-3 space-y-4">
      <div className="float-right mb-4 w-full">
        <button
          onClick={onOpen}
          className="float-right w-full rounded-xl border-2 border-brand-500 px-5 py-3 text-base font-medium text-brand-500 transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 dark:border-brand-400 dark:bg-brand-400/10 dark:text-white dark:hover:bg-brand-300/10 dark:active:bg-brand-200/10 md:w-1/4"
        >
          Add restaurant
        </button>
      </div>
      {isLoading ? ( // Render loading indicator while loading
        <div className="flex h-[300px] w-full items-center justify-center">
          <p className="text-lg text-gray-500">Loading...</p>
        </div>
      ) : allData.length > 0 ? (
        <ColumnsTable
          columnsData={columns}
          tableData={allData}
          handleDelete={handleDelete}
          handleEdit={handleEdit} 
          setCurrData={setCurrData}
        />
      ) : (
        <div className="flex h-[300px] w-full items-center justify-center">
          <p className="text-lg text-gray-500">No Restaurants found</p>
        </div>
      )}
      <AddRestaurant
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        getRestauRants={getRestauRants}
      />
      { currData && <EditRestaurant
        isOpen={isEdit}
        onOpen=""
        onClose={()=> setIsEdit(false)}
        getRestauRants={getRestauRants}
        currData={currData}
       />}
    </div>
  );
};

export default RestaurantLists;
